import { Component, ErrorInfo } from "react";
import { Notifier } from "@airbrake/browser";
import ErrorMessage from "@components/ErrorBoundary/ErrorMessage";
import type { ErrorBoundaryProps, ErrorBoundaryState } from "@src/types/AppTypes";

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  private airbrake: Notifier | null;
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
    this.airbrake = null;
    if (import.meta.env.MODE === "production") {
      this.airbrake = new Notifier({
        projectId: import.meta.env.VITE_REACT_AIRBRAKE_PROJECTID,
        projectKey: import.meta.env.VITE_REACT_AIRBRAKE_PROJECTKEY,
      });
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Display fallback UI
    this.setState({ hasError: true });
    // Send error to Airbrake
    if (import.meta.env.MODE === "production" && this.airbrake) {
      this.airbrake.notify({
        error: error,
        params: { info: info },
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorMessage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
